export const initialValuesFormDocumentosAfiliados = {
    documentoUCP: '',
    documentoACM: '',
    documentoGES: '',
    documentoAnexo: []
};